import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '../../../../utils/track-by';
import { PopoverRef } from '../../../../components/popover/popover-ref';
import {AuthenticationService} from '../../../../../app/shared/services/authentication.service';
import {
  Setup2FAModalComponent
} from '../../../../../app/user-management/edit/setup-2FA-modal/setup-2FA-modal.component';
import {Qrcode2FAComponent} from '../../../../../app/shared/components/qrcode-2FA/qrcode-2FA.component';
import {MatDialog} from '@angular/material/dialog';

export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: string;
  colorClass: string;
}

@Component({
    selector: 'vex-toolbar-user-dropdown',
    templateUrl: './toolbar-user-dropdown.component.html',
    styleUrls: ['./toolbar-user-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToolbarUserDropdownComponent implements OnInit {

  items: MenuItem[] = [
    // {
    //   id: '1',
    //   icon: 'mat:account_circle',
    //   label: 'Můj profil',
    //   description: 'Osobní informace',
    //   colorClass: 'text-teal',
    //   route: '/apps/social'
    // },
    // {
    //   id: '2',
    //   icon: 'mat:list_alt',
    //   label: 'Přiřazené úkoly',
    //   description: 'Úkoly ke splnění',
    //   colorClass: 'text-amber',
    //   route: '/apps/scrumboard'
    // },
  ];

  trackById = trackById;

  constructor(private cd: ChangeDetectorRef,
              public authService: AuthenticationService,
              private dialog: MatDialog,
              private popoverRef: PopoverRef<ToolbarUserDropdownComponent>) { }

  ngOnInit(): void {
  }

  close(): void {
    this.popoverRef.close();
    this.authService.logout();
  }

  open2FAQRCode(): void {
    const dialogRef = this.dialog.open(Qrcode2FAComponent, {width: '300px'});
    dialogRef.afterClosed().subscribe(async result => {
    });
  }

}
